'use client';
import { Tag } from '@energy-retailer/icons';
import { getCookie } from 'cookies-next';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { RichText } from '@/components/rich-text';
import { Text } from '@/components/text';
import type { Maybe, PromoSettingsDescription } from '@/app/generated/graphql';
import type { Document } from '@contentful/rich-text-types';
import type { CampaignID } from '@energy-retailer/constants';
import { PROMO_ID_COOKIE } from '@/constants';
import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';

type PromoProps = {
  id: CampaignID;
  title: Maybe<string>;
  description?: Maybe<PromoSettingsDescription>;
};

export const Promo = ({ id, title, description }: PromoProps) => {
  const { setPromotionId } = useJoinFormStore();
  const router = useRouter();
  const promoId = getCookie(PROMO_ID_COOKIE);

  if (promoId !== id) {
    router.refresh();
  }

  useEffect(() => {
    setPromotionId(id || null);
  }, [id, setPromotionId]);

  return (
    <div className="rounded-rad-a bg-white p-d shadow max-md:py-c md:p-b">
      <div className="mb-a flex items-center">
        <Tag className="mr-a h-icon w-icon text-pink" />
        <Text
          as="h4"
          variant="h4"
        >
          {title}
        </Text>
      </div>
      {description ? (
        <RichText
          links={description.links}
          document={description.json as Document}
          bodyVariant="body2"
        />
      ) : null}
    </div>
  );
};
